import { StoreType } from '@tock/shared/utils/connect';

export const getFeatures = (state: StoreType) => state.features.features;
